/** The journey page's sections, addressable through the `tab` query. */
export type WorkspaceTab = 'summary' | 'draft' | 'items' | 'documents' | 'receiving' | 'activity' | 'notes';

export const WORKSPACE_TABS: Array<[WorkspaceTab, string]> = [
  ['summary', 'Summary'],
  ['draft', 'Draft'],
  ['items', 'Items'],
  ['documents', 'Documents'],
  ['receiving', 'Receiving & costs'],
  ['activity', 'Activity'],
  ['notes', 'Notes'],
];
